export default [
    { name: "starting_time", label: "Godzina rozpoczęcia" },
    { name: "ending_time", label: "Godzina zakończenia" }
]